import Api from '../../api'
import { call, put, takeLatest } from 'redux-saga/effects'
import { LOGOUT } from 'portal-modules/auth/redux/modules/user'
import createRequestSaga from 'portal-modules/common/redux/create-request-saga'
import createFormAction from 'portal-modules/common/redux/create-form-action'

// action types
const REQUEST_REVIEWS = 'rp/reviews/REQUEST_REVIEWS'
const RECEIVE_REVIEWS = 'rp/reviews/RECEIVE_REVIEWS'
const REQUEST_SAVE = 'rp/reviews/REQUEST_SAVE'
const RECEIVE_SAVE = 'rp/reviews/RECEIVE_SAVE'

// reducer
export default (state = {}, { payload, type }) => {
  switch (type) {
    case RECEIVE_REVIEWS:
    case RECEIVE_SAVE:
      return { ...state, ...payload }
    case LOGOUT:
      return {}
    default:
      return state
  }
}

// action creators
export const requestReviews = callback => ({
  type: REQUEST_REVIEWS,
  callback,
})

export const receiveReviews = payload => ({
  type: RECEIVE_REVIEWS,
  payload,
})

export const requestSave = createFormAction(REQUEST_SAVE)

export const receiveSave = payload => ({
  type: RECEIVE_SAVE,
  payload,
})

// sagas
function* fetchReviews({ callback }) {
  const { reviews } = yield call(Api.getReviews)
  yield put(
    receiveReviews(
      reviews.reduce((obj, review) => ({ ...obj, [review.id]: review }), {}),
    ),
  )
  if (typeof callback == 'function' && !reviews?.length) {
    callback()
  }
}

function* watchRequestedReviews() {
  yield takeLatest(
    REQUEST_REVIEWS,
    createRequestSaga(fetchReviews, {
      key: 'reviews',
      message: __('Looking up your reviews'),
    }),
  )
}

function* saveReview({ payload }) {
  const { review } = yield call(Api.saveReview, payload)
  yield put(receiveSave({ [review.id]: review }))
}

function* watchRequestedSave() {
  yield takeLatest(
    REQUEST_SAVE,
    createRequestSaga(saveReview, {
      key: 'reviews',
      message: __('Saving'),
      successMessage: __('Saved successfully'),
      write: true,
    }),
  )
}

export const sagas = [watchRequestedReviews, watchRequestedSave]
